import React, { useState, useRef } from 'react'
import styled from 'styled-components'
import { navigate } from 'gatsby'

import useOnClickOutside from 'utils/hooks/useOnClickOutside'
import FontAwesome from 'components/FontAwesome'
import { DEFAULT_LANG } from 'config/languages'

import { DecoratedBox, StyledControlBtn } from './styles'

export default function LangSelector({ languages, path }) {
   const [open, setOpen] = useState(false)
   const mainRef = useRef(null)

   useOnClickOutside(mainRef, () => setOpen(false))
   function handleOnClick(lang) {
      let url

      if (lang === DEFAULT_LANG) {
         url = path
      } else {
         url = `/${lang}${path}`
      }

      navigate(url)
   }

   return (
      <Wrapper ref={mainRef}>
         <StyledControlBtn onClick={() => setOpen(!open)} aria-label="Open language menu">
            <FontAwesome icon="globe" />
         </StyledControlBtn>
         <Menu open={open}>
            {languages.map((item) => (
               <MenuBtn key={item.lang} disabled={item.disabled} onClick={() => handleOnClick(item.lang)}>
                  <span>/</span>
                  <span>{item.label}</span>
               </MenuBtn>
            ))}
         </Menu>
      </Wrapper>
   )
}

const Wrapper = styled.div`
   position: relative;
`

const Menu = styled(DecoratedBox)`
   position: absolute;
   top: 130%;
   right: 0;
   min-width: 150px;
   display: ${({ open }) => (open ? 'block' : 'none')};
`

const MenuBtn = styled.button`
   width: 100%;
   padding: 0.5rem 1rem;
   text-align: left;
   border: none;
   background: none;
   color: ${({ theme }) => theme.text};
   cursor: pointer;
   font-size: 16px;
   line-height: 1;
   display: flex;
   align-items: center;
   gap: 4px;

   span:first-of-type {
      opacity: 0;
      color: ${({ theme }) => theme.colors.hotCinnamon};
      font-size: 20px;
      transition: transform 0.2s linear, opacity 0.2s linear;
      font-family: "Arial";
      font-weight: 700;
   }

   span:last-of-type {
      transform: translateX(-9px);
      display: inline-block;
      transition: transform 0.2s linear, opacity 0.2s linear;
   }

   &:hover {
      background: ${({ theme }) => theme.backgroundHover};

      span:first-of-type {
         opacity: 1;
      }

      span:last-of-type {
         transform: translateX(0px);
      }
   }

   &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
   }
`
